import React from 'react'
import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {Button} from '../../../../_gori/partials/widgets'

type Props = {
  show: boolean
  handleClose: () => void
  data: any
}

export const PackageInfoModal: React.FC<Props> = ({show, handleClose, data}) => {
  const intl = useIntl()

  return (
    <Modal
      show={show}
      onHide={handleClose}
      dialogClassName='modal-size-lg h-auto'
      contentClassName='modal-padding'
      id='gori_modal_view_package_info'
      tabIndex={-1}
      aria-hidden='true'
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title bsPrefix={'fw-bolder fs-1'}>
          {intl.formatMessage({id: 'PACKAGE_INFORMATION'})}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='row'>
          <div className='col-12 d-flex mb-3' style={{color: '#94A3B8'}}>
            <div className='col-6 text-uppercase text-start fw-bolder fs-5 lh-lg'>
              {intl.formatMessage({id: 'DIMENSIONS'})}
            </div>
            <div className='col-3 text-uppercase text-start fw-bolder fs-5 lh-lg'>
              {intl.formatMessage({id: 'WEIGHT'})}
            </div>
            <div className='col-3 text-uppercase text-start fw-bolder fs-5 lh-lg'>
              {intl.formatMessage({id: 'PACKAGE_COUNT'})}
            </div>
          </div>
        </div>
        <div className='row'>
          {Object.values(data || {}).map((parcel: any, index) => (
            <div key={index} className='col-12 my-3'>
              <div className='d-flex fs-5 fw-bold' style={{color: '#94A3B8'}}>
                <div className='col-6 d-flex align-items-center'>
                  <span className='fs-6 fw-bold' style={{width: '20px'}}>
                    {index + 1}.
                  </span>
                  <span className='' style={{color: '#1E2A3B'}}>
                    {parcel.length} {parcel.dimension_unit} (L) x {parcel.width}{' '}
                    {parcel.dimension_unit} (W) x {parcel.height} {parcel.dimension_unit} (H)
                  </span>
                </div>
                <div className='col-3'>
                  {parcel.weight} {parcel.weight_unit}
                </div>
                <div className='col-3'>{parcel.package_count || 1}</div>
              </div>
            </div>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className='btn btn-advanced-secondary'
          label={intl.formatMessage({id: 'CLOSE'})}
          loadingText={intl.formatMessage({id: 'CLOSE'})}
          event={handleClose}
        />
      </Modal.Footer>
    </Modal>
  )
}
